import { render, staticRenderFns } from "./MarketSupervision.vue?vue&type=template&id=4412203a&scoped=true"
import script from "./MarketSupervision.vue?vue&type=script&lang=js"
export * from "./MarketSupervision.vue?vue&type=script&lang=js"
import style0 from "./MarketSupervision.vue?vue&type=style&index=0&id=4412203a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412203a",
  null
  
)

export default component.exports